import { render, staticRenderFns } from "./PostLoginSurvey.vue?vue&type=template&id=c229fcaa&scoped=true"
import script from "./PostLoginSurvey.vue?vue&type=script&lang=js"
export * from "./PostLoginSurvey.vue?vue&type=script&lang=js"
import style0 from "./PostLoginSurvey.vue?vue&type=style&index=0&id=c229fcaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c229fcaa",
  null
  
)

export default component.exports